export default {
  type: 'Container',
  components: [
    {
      type: 'Component',
      skin: 'skins.viewer.VectorImageSkin',
      layout: {
        width: 33,
        height: 32,
        x: 33,
        y: 34,
        scale: 1,
        rotationInDegrees: 0,
        fixedPosition: false,
      },
      componentType: 'wysiwyg.viewer.components.VectorImage',
      metaData: {
        pageId: 'xtiev',
      },
      parent: 'comp-kgt66qyx',
      data: {
        type: 'VectorImage',
        metaData: {
          isPreset: false,
          schemaVersion: '1.0',
          isHidden: false,
          pageId: 'xtiev',
        },
        alt: '',
        svgId: '11062b_10fa2a54cea44cc591fcf6d560a719e1.svg',
        title: 'Star outline',
      },
      props: {
        type: 'VectorImageProperties',
        metaData: {
          schemaVersion: '1.0',
          autoGenerated: false,
          pageId: 'xtiev',
        },
        displayMode: 'stretch',
        flip: 'none',
      },
      design: {
        type: 'VectorImageDesignData',
        metaData: {
          isPreset: false,
          schemaVersion: '1.0',
          isHidden: false,
          pageId: 'xtiev',
        },
        overrideColors: {
          color1: '#FAA255',
        },
        shapeStyle: {
          opacity: 1,
          strokeWidth: 4,
          stroke: '#5E97FF',
          strokeOpacity: 1,
          enableStroke: false,
        },
      },
      transitions: {
        type: 'TransitionData',
        'timing-function': 'ease-in-out',
        duration: 0.4,
        delay: 0,
        metaData: {
          isPreset: false,
          schemaVersion: '1.0',
          isHidden: false,
          pageId: 'xtiev',
        },
      },
      transformations: {
        type: 'TransformData',
        origin: {
          x: {
            value: 50,
            type: 'percentage',
          },
          y: {
            value: 50,
            type: 'percentage',
          },
        },
        metaData: {
          isPreset: false,
          schemaVersion: '1.0',
          isHidden: false,
          pageId: 'xtiev',
        },
      },
      scopedTransformations: {
        'variants-kgt66r04': {
          type: 'TransformData',
          scale: {
            x: 1.2,
            y: 1.2,
          },
          metaData: {
            isPreset: false,
            schemaVersion: '1.0',
            isHidden: false,
            pageId: 'xtiev',
          },
        },
      },
      style: {
        type: 'ComponentStyle',
        metaData: {
          isPreset: false,
          schemaVersion: '1.0',
          isHidden: false,
          pageId: 'xtiev',
        },
        style: {
          properties: {},
          propertiesSource: {},
          groups: {},
        },
        componentClassName: 'wysiwyg.viewer.components.VectorImage',
        styleType: 'custom',
        skin: 'skins.viewer.VectorImageSkin',
      },
      mobileStructure: {
        layout: {
          width: 30,
          height: 29,
          x: 35,
          y: 35,
          scale: 1,
          rotationInDegrees: 0,
          fixedPosition: false,
        },
        metaData: {
          originalCompId: 'comp-kgt66r061',
          author: 'studio',
        },
      },
    },
  ],
  skin: 'wysiwyg.viewer.skins.area.CircleArea',
  layout: {
    width: 100,
    height: 100,
    x: 440,
    y: 185,
    scale: 1,
    rotationInDegrees: 0,
    fixedPosition: false,
  },
  componentType: 'mobile.core.components.Container',
  metaData: {
    pageId: 'xtiev',
  },
  parent: 'xtiev',
  variants: {
    'variants-kgt66r04': {
      componentId: 'comp-kgt66qyx',
      type: 'Hover',
      metaData: {
        isPreset: false,
        schemaVersion: '1.0',
        isHidden: false,
        pageId: 'xtiev',
      },
    },
  },
  transitions: {
    type: 'TransitionData',
    'timing-function': 'ease-in-out',
    duration: 0.4,
    delay: 0,
    metaData: {
      isPreset: false,
      schemaVersion: '1.0',
      isHidden: false,
      pageId: 'xtiev',
    },
  },
  scopedTransformations: {
    'variants-kgt66r04': {
      type: 'TransformData',
      zLayer: 'BELOW_PINNED',
      metaData: {
        isPreset: false,
        schemaVersion: '1.0',
        isHidden: false,
        pageId: 'xtiev',
      },
      rotate: 0,
    },
  },
  scopedStyles: {
    'variants-kgt66r04': {
      type: 'ComponentStyle',
      metaData: {
        isPreset: false,
        schemaVersion: '1.0',
        isHidden: false,
        pageId: 'xtiev',
      },
      style: {
        properties: {
          'alpha-bg': '1',
          'alpha-brd': '1',
          bg: 'rgba(253,236,190,1)',
          'boxShadowToggleOn-shd': 'false',
          brd: '#D3E1F0',
          brw: '0',
          shd: '0px 1px 4px 0px rgba(0,0,0,0.6)',
        },
        propertiesSource: {
          'alpha-bg': 'value',
          'alpha-brd': 'value',
          bg: 'value',
          'boxShadowToggleOn-shd': 'value',
          brd: 'value',
          brw: 'value',
          shd: 'value',
        },
        groups: {},
      },
      componentClassName: 'mobile.core.components.Container',
      pageId: '',
      compId: '',
      styleType: 'custom',
      skin: 'wysiwyg.viewer.skins.area.CircleArea',
    },
  },
  style: {
    type: 'ComponentStyle',
    metaData: {
      isPreset: false,
      schemaVersion: '1.0',
      isHidden: false,
      pageId: 'xtiev',
    },
    style: {
      properties: {
        'alpha-bg': '1',
        'alpha-brd': '1',
        bg: 'rgba(255,255,255,1)',
        'boxShadowToggleOn-shd': 'false',
        brd: '#FACF4B',
        brw: '3',
        shd: '0px 1px 4px 0px rgba(0,0,0,0.6)',
      },
      propertiesSource: {
        'alpha-bg': 'value',
        'alpha-brd': 'value',
        bg: 'value',
        'boxShadowToggleOn-shd': 'value',
        brd: 'value',
        brw: 'value',
        shd: 'value',
      },
      groups: {},
    },
    componentClassName: 'mobile.core.components.Container',
    pageId: '',
    compId: '',
    styleType: 'custom',
    skin: 'wysiwyg.viewer.skins.area.CircleArea',
  },
  mobileStructure: {
    layout: {
      width: 100,
      height: 100,
      x: 110,
      y: 10,
      scale: 1,
      rotationInDegrees: 0,
      fixedPosition: false,
    },
    metaData: {
      originalCompId: 'comp-kgt66qyx',
      author: 'studio',
    },
  },
  activeModes: {},
};
